import React from "react"
import { Drawer, Grid } from "@mui/material"
import { PagesTitle, SubTitle } from "../../ui/Text"
import { BLACK } from "../../ui/Colors"
import CloseIcon from '@mui/icons-material/Close'
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { SupportArticles } from "./SupportArticles"
import { AltButton } from "../../ui/Button"
import { useAppSelector } from "../../../redux/hooks"
import { ArticleSection } from "../../../redux/supportAndGuides/supportArticlesType"
import { Separator } from "../../ui/Separator"

export const SupportDrawer = ({ open, setOpen }: { open: boolean, setOpen: React.Dispatch<React.SetStateAction<Boolean>> }) => {
    const { articles } = useAppSelector((state) => state.supportArticles)
    const firstStepsArticles = articles && articles.filter((el) => el.section === ArticleSection.FIRST_STEPS)
    const useCasesArticles = articles && articles.filter((el) => el.section === ArticleSection.USECASES)

    const handleSupport = () => {
        window.open(
            "https://karyon.notion.site/1eb41a4c16308025adf6e53541ffb787?pvs=105",
            '_blank'
        )
    }

    return (
        <Drawer
            anchor="right"
            PaperProps={{ sx: { width: '35vw' } }
            }
            open={open}
            onClose={() => setOpen(false)}
        >
            <Grid p="1vw" position="sticky" container >
                <Grid>
                    <CloseIcon
                        sx={{
                            position: 'absolute',
                            cursor: 'pointer',
                            right: '1vw',
                            top: '2vh',
                        }}
                        onClick={() => setOpen(false)}
                    />
                    <Grid container alignItems="center" justifyContent="center" flexWrap="nowrap">
                        <HelpOutlineOutlinedIcon
                            sx={{
                                color: BLACK,
                                width: 45,
                                height: 45,

                            }}
                        />
                        <Grid padding="1vh 0">
                            <PagesTitle color={BLACK}>Guides et support</PagesTitle>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Grid p="1vw">
                <SubTitle color={BLACK} bold mb="2vh">Support</SubTitle>
                <AltButton onClick={handleSupport}>Signaler un problème</AltButton>
                <Separator mt="4vh" mb="4vh" />
                <SubTitle color={BLACK} bold mb="2vh">Premiers pas</SubTitle>
                {articles && firstStepsArticles.map((el, index) => <SupportArticles title={el.title} description={el.description} link={el.link} key={index} imageName={el.image} />)}
                <SubTitle color={BLACK} bold mt="2vh" mb="2vh">Cas d'usage métiers</SubTitle>
                {articles && useCasesArticles.map((el, index) => <SupportArticles title={el.title} description={el.description} link={el.link} key={index} imageName={el.image} />)}
            </Grid>
        </Drawer >)
}